<template>
  <div class="bom-hierarchy-nested-tree-editor">
    <div class="bom-hierarchy-nestable-wrapper">
      <vue-nestable v-model="nestableItems" @change="handleChange">
        <vue-nestable-handle slot-scope="{ item }" :item="item">
          <span component-property="row_number">{{ item.row_number }}</span>
          <!-- <span v-for="prop in properties" :key="prop" :component-property="prop">
            {{ item.row_data[columns[prop]] }}
          </span> -->
        </vue-nestable-handle>
      </vue-nestable>
    </div>
    <Modal v-model="showBomFileContentFoundModal"
           :ok-text="$t('bom_hierarchy_nested_tree_editor.local_bom_file_rows_found_modal_ok_text')"
           :cancel-text="$t('bom_hierarchy_nested_tree_editor.local_bom_file_rows_found_modal_cancel_text')"
           :title="$t('bom_hierarchy_nested_tree_editor.local_bom_file_rows_found')"
           @on-ok="handleLoadBomHierarchyFromLocalstorage"
           @on-cancel="handleRemoveBomHierarchyFromLocalStorage">
      <div>{{ $t('bom_hierarchy_nested_tree_editor.confirm_to_load_bom_file_from_local') }}</div>
    </Modal>
    <Spin fix size="large" v-if="loading">
      <slot name="loading"></slot>
    </Spin>
  </div>
</template>

<script>
import { VueNestable, VueNestableHandle } from 'vue-nestable'
export default {
  name: 'BOMHierarchyNestedTreeEditor',
  components: {
    VueNestable,
    VueNestableHandle
  },
  props: {
    rows: {
      type: Array,
      required: true
    },
    columns: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    saveOnEditing: {
      type: Boolean,
      default: false
    },
    tempStorageVar: String,
    properties: [Object, Array]
  },
  data () {
    return {
      nestableItems: [],
      showBomFileContentFoundModal: false
    }
  },
  mounted () {
    // Load from localStorage and let user to decided if he/she wants to use from the temporary storage.
    // It is possible when user leave the page accidently and they want to come back and edit again.
    if (localStorage.getItem(this.tempStorageVar)) {
      this.showBomFileContentFoundModal = true
    }
    this.preprocessNestableItems(this.rows)
  },
  methods: {
    preprocessNestableItems (data) {
      if (data && data.length > 0) {
        this.nestableItems = data
      }
    },
    handleChange () {
      // Emit the changes
      this.$emit('on-change', this.nestableItems)

      // If the saveOnEditing flag is on, anytime the nestable component items changed will trigger the savehandler.
      // The parent component will be responsible for defining the save handler implementation.
      if (this.saveOnEditing) {
        this.handleSave()
      } else {
        localStorage.setItem(this.tempStorageVar, JSON.stringify(this.nestableItems))
      }
    },
    handleLoadBomHierarchyFromLocalstorage () {
      this.nestableItems = JSON.parse(localStorage.getItem(this.tempStorageVar))
      localStorage.removeItem(this.tempStorageVar)
    },
    handleRemoveBomHierarchyFromLocalStorage () {
      localStorage.removeItem(this.tempStorageVar)
    }
  },
  watch: {
    rows: {
      handler () {
        this.preprocessNestableItems(this.rows)
      },
      deep: true
    }
  }
}
</script>

<style lang="less">

.bom-hierarchy-nested-tree-editor {
  span[component-property] {
    display: inline-block;
    padding: 0 4px;
    overflow: hidden;
  }
  span[component-property="row_number"] {
    font-size: 120%;
    font-weight: bold;
  }
  span[component-property="line_quantity"] {
    text-align: right;
  }
  span[component-property="unit_name"] {
    width: 40px;
  }
  span[component-property="part_number"] {
    width: 100px;
  }

 /*
  * Style for nestable
  */
  .nestable {
    position: relative;
  }
  .nestable-rtl {
    direction: rtl;
  }
  .nestable .nestable-list {
    margin: 0;
    padding: 0 0 0 40px;
    list-style-type: none;
  }
  .nestable-rtl .nestable-list {
    padding: 0 40px 0 0;
  }
  .nestable > .nestable-list {
    padding: 0;
  }

  .nestable-item,
  .nestable-item-copy {
    margin: 10px 0 0;
  }
  .nestable-item:first-child,
  .nestable-item-copy:first-child {
    margin-top: 0;
  }
  .nestable-item .nestable-list,
  .nestable-item-copy .nestable-list {
    margin-top: 10px;
  }
  .nestable-item {
    position: relative;
  }
  .nestable-item.is-dragging .nestable-list {
    pointer-events: none;
  }
  .nestable-item.is-dragging * {
    opacity: 0;
    filter: alpha(opacity=0);
  }
  .nestable-item.is-dragging:before {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(243, 242, 242); // rgba(106, 127, 233, 0.274);
    border: 1px dashed #999;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }
  .nestable-drag-layer {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    pointer-events: none;
  }
  .nestable-rtl .nestable-drag-layer {
    left: auto;
    right: 0;
  }
  .nestable-drag-layer > .nestable-list {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0;
    background-color: rgb(226, 224, 224); // rgba(106, 127, 233, 0.274);
  }
  .nestable-rtl .nestable-drag-layer > .nestable-list {
    padding: 0;
  }
  .nestable [draggable="true"] {
    cursor: move;
  }
  .nestable-handle {
    display: inline;
  }
}

.bom-hierarchy-nested-tree-editor {
  width: 250px;
  background-color: white;
  padding: 15px;
  box-sizing: border-box;
  margin-top: 18px;
  float: left;
  height: ~"calc(100vh - 255.2px)";
  overflow-y: auto;
  .ivu-spin-fix {
    z-index: 9;
  }
}
</style>
